var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"app-wrapper"}},[_c('main',{attrs:{"id":_vm.$route.name}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('firstTimeAccess')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }